import { createContext, useContext, useEffect, useState } from "react";
import { login as apiLogin, getMe, TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [authed, setAuthed] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setChecking(false);
      return;
    }
    getMe()
      .then(() => setAuthed(true))
      .catch(() => localStorage.removeItem(TOKEN_KEY))
      .finally(() => setChecking(false));
  }, []);

  const signIn = async (password) => {
    const { token } = await apiLogin(password);
    localStorage.setItem(TOKEN_KEY, token);
    setAuthed(true);
  };

  const signOut = () => {
    localStorage.removeItem(TOKEN_KEY);
    setAuthed(false);
  };

  return (
    <AuthContext.Provider value={{ authed, checking, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
